import React from "react";
import CommonBanner from "../component/Common/CommonBanner";
import ImageGuideArea from "../component/ImageGuide";

const ImageGuidePage = () => {
  return (
    <>
      <CommonBanner heading="Image asset guide" pagination="Image asset guide" />
      <ImageGuideArea />
    </>
  );
};

export default ImageGuidePage;
